
/**
 * @param {string} ruleName
 * @returns {string}
 */
export const getDocsUrl = (ruleName) => `https://github.com/BellCubeDev/eslint-plugin-react-no-manual-memo/blob/main/docs/${ruleName}.md`;
